import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, LL_H_C, ModuleFE_Toaster, openContent, TS_Card, TS_Input, TS_Loader } from '@nu-art/thunderstorm-frontend/index';
import './Component_ResolutionFunctionCard.scss';
import { MUSTNeverHappenException, voidFunction } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
import { ActionsMenu_BaseManagerUI, Dialog_Confirmation } from '@app/styles';
import { Renderer_Transition } from '../../Page_PathwayEditor/renderers/Renderer_Transition.js';
import { dispatch_onDuplicateTransitionTerm } from '../dispatchers.js';
import { ModuleFE_PathwayTransition } from '../../../_entity.js';
import { TS_EditableItemStatus } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemStatus/TS_EditableItemStatus';
import { dispatch_FocusResolutionFunction } from '../../Page_PathwayEditor/dispatchers.js';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/editable-item';
import { Component_TermsAndExpression } from '@app/hcs-frontend/expression';
export class Component_ResolutionFunctionCard extends TS_EditableItemComponentProto {
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.className = nextProps.className;
        state.collapse = nextProps.collapsed;
        state.transitionId = nextProps.transitionId;
        state.index = nextProps.index;
        state.focused = true;
        state.editPriority ??= false;
        state.updatingTransition ??= false;
        return state;
    }
    componentDidMount() {
        const element = document.getElementById(this.state.transitionId);
        if (element)
            element.addEventListener('click', this.dispatchFocusResolutionFunction.bind(this), true);
    }
    componentWillUnmount() {
        const element = document.getElementById(this.state.transitionId);
        if (element)
            element.removeEventListener('click', this.dispatchFocusResolutionFunction.bind(this), true);
    }
    componentDidUpdate() {
        if (this.state.editPriority)
            return document.addEventListener('click', this.listenOnClickAway);
        document.removeEventListener('click', this.listenOnClickAway);
    }
    listenOnClickAway = (e) => {
        const targetElement = e.target;
        if (targetElement.classList.contains('priority-input'))
            return;
        // submit data on click away
        const input = document.getElementsByClassName('priority-input')[0];
        return this.updateTransitionIndex(input.value);
    };
    deleteTerm = () => {
        Dialog_Confirmation.show({
            header: 'Are You Sure?',
            buttons: [{
                    label: 'Yes, Delete',
                    isAsync: true,
                    action: async () => {
                        await this.state.editable.delete();
                    }
                },
                {
                    label: 'Don\'t Delete',
                    isPreferred: true,
                    action: voidFunction,
                }],
            content: () => {
                const transition = ModuleFE_PathwayTransition.cache.unique(this.props.transitionId);
                if (!transition)
                    throw new MUSTNeverHappenException(`transition with id ${this.props.transitionId}`);
                return _jsxs(_Fragment, { children: [_jsx("div", { children: "You're about to delete transition resolution function" }), _jsx(Renderer_Transition, { transition: transition, className: 'green' })] });
            }
        });
    };
    dispatchFocusResolutionFunction() {
        dispatch_FocusResolutionFunction.dispatchUI(this.state.transitionId, this.state.editable);
    }
    updateTransitionIndex = (value) => {
        const numericValue = Number(value);
        const transition = ModuleFE_PathwayTransition.cache.unique(this.state.transitionId);
        if (!transition)
            throw new MUSTNeverHappenException(`cannot find transition with id ${this.state.transitionId}`);
        // fail fast if value didn't change
        if (transition.priorityIndex === numericValue)
            return this.setState({ editPriority: false });
        if (isNaN(numericValue))
            return ModuleFE_Toaster.toastError('Cannot accept a non numeric value as priority index');
        if (numericValue <= 0 || numericValue > 9)
            return ModuleFE_Toaster.toastError('Index must be a number bigger than 0 and smaller than 9');
        this.setState({ updatingTransition: true }, async () => {
            await ModuleFE_PathwayTransition._v1.updateTransitionsPriority({
                transitionId: this.state.transitionId,
                newIndex: numericValue
            }).executeSync();
            // setState (not in-place mutation) so the loader actually clears; deriveStateFromProps uses `??=`
            // for these flags, so a later parent re-render (from the priority re-sort) won't re-enable them.
            this.setState({ updatingTransition: false, editPriority: false });
        });
    };
    renderTermEditor = () => {
        if (this.state.collapse)
            return '';
        return _jsx(Component_TermsAndExpression, { hideCards: true, editable: this.state.editable });
    };
    renderActionMenu = () => {
        const menuActions = [
            {
                label: 'Remove Transition Term',
                action: this.deleteTerm
            },
            ...(this.props.onDuplicateTransition ? [{
                    label: 'Duplicate Transition',
                    action: this.props.onDuplicateTransition
                }] : []),
            ...(this.props.onDeleteTransition ? [{
                    label: 'Delete Transition',
                    action: this.props.onDeleteTransition
                }] : []),
            ...(this.props.hideDuplicateAction ? [] : [{
                    label: 'Duplicate Transition Term',
                    action: () => {
                        dispatch_onDuplicateTransitionTerm.dispatchUI(this.state.editable.item);
                    }
                }]),
            {
                label: 'Change Transition Priority',
                action: () => this.setState({ editPriority: true })
            }
        ];
        return _jsx(ICONS.more.component, { ...openContent.popUp.bottom('pop-up__resolution-function-card-actions', () => _jsx(ActionsMenu_BaseManagerUI, { actions: menuActions }), 10) });
    };
    renderTransitionInfo = () => {
        const transition = ModuleFE_PathwayTransition.cache.unique(this.state.transitionId);
        if (!transition)
            throw new MUSTNeverHappenException(`transition with id ${this.props.transitionId} not found`);
        const arrowClassName = _className('collapse-arrow', this.state.collapse && 'collapsed');
        return _jsxs(LL_H_C, { className: 'match_width', style: { gap: '7px' }, children: [this.props.onDragStart && _jsx(ICONS.dragHandle.component, { className: 'transition-drag-handle', draggable: true, onDragStart: this.props.onDragStart, onDragEnd: this.props.onDragEnd }), this.renderTransitionIndex(), _jsx(ICONS.advisor_v4_arrow.component, { className: arrowClassName, onClick: () => this.props.onCollapse(this.state.transitionId) }), _jsxs(LL_H_C, { className: 'match_width flex__space-between', children: [_jsx("div", { className: 'card-title', children: transition.label }), _jsxs(LL_H_C, { style: { gap: 10 }, children: [_jsx(TS_EditableItemStatus, { editable: this.state.editable }), this.renderActionMenu()] })] })] });
    };
    renderTransitionIndex = () => {
        if (!this.state.editPriority)
            return _jsx("div", { onDoubleClick: () => this.setState({ editPriority: true }), className: 'card-priority', children: this.state.index });
        const dbTransition = ModuleFE_PathwayTransition.cache.unique(this.state.transitionId);
        if (!dbTransition)
            throw new MUSTNeverHappenException(`cannot find db transition with id ${this.state.transitionId}`);
        return _jsxs(_Fragment, { children: [_jsx(TS_Input, { type: 'number', className: 'priority-input', value: String(dbTransition.priorityIndex), onBlur: this.updateTransitionIndex }), this.state.updatingTransition && _jsx(TS_Loader, {})] });
    };
    renderSaveButton = () => {
        if (!this.state.focused || this.state.collapse)
            return '';
        const className = _className('preferred-action', 'resolution-function-card__save-button');
        return _jsx(_Fragment, { children: _jsx(Button, { variant: 'primary', className: className, onClick: async () => await this.state.editable.save(), children: "Save" }) });
    };
    render() {
        const className = _className('resolution-function-card', this.props.className);
        return _jsxs(TS_Card, { id: this.state.transitionId, "data-term-item": this.props.transitionId, className: className, children: [this.renderTransitionInfo(), this.renderTermEditor(), this.renderSaveButton()] });
    }
}
//# sourceMappingURL=Component_ResolutionFunctionCard.js.map